// extracted by mini-css-extract-plugin
export var arrow = "styles-module--arrow--bf9fa";
export var borderBold = "styles-module--borderBold--2b47d";
export var button = "styles-module--button--bb1d3";
export var companyWrapper = "styles-module--companyWrapper--f74a1";
export var descriptionWrapper = "styles-module--descriptionWrapper--35b36";
export var first = "styles-module--first--d22ac";
export var image = "styles-module--image--34dc0";
export var labelWrapper = "styles-module--labelWrapper--e8b2a";
export var later = "styles-module--later--5b8d8";
export var link = "styles-module--link--a17fe";
export var logo = "styles-module--logo--d3486";
export var ranking = "styles-module--ranking--81b3a";
export var rankingWrapper = "styles-module--rankingWrapper--9fe2d";
export var small = "styles-module--small--15b67";
export var transparent = "styles-module--transparent--df7eb";
export var trophy = "styles-module--trophy--02146";
export var type = "styles-module--type--be64f";
export var wrapper = "styles-module--wrapper--3ded5";